// extracted by mini-css-extract-plugin
export var actionButton = "_qn-0";
export var actionMenuContainer = "_qn-i";
export var bubble = "_qn-2";
export var bubbleActionMenu = "_qn-j";
export var bubbleContext = "_qn-6";
export var bubbleItems = "_qn-7";
export var customer = "_qn-3";
export var divider = "_qn-8";
export var fileList = "_qn-9";
export var hiddenComment = "_qn-o";
export var infoAbove = "_qn-a";
export var internal = "_qn-4";
export var lightActionButton = "_qn-1";
export var link = "_qn-b";
export var merchant = "_qn-5";
export var message = "_qn-c";
export var profilePicture = "_qn-e";
export var quillToolbarContainer = "_qn-f";
export var senderDate = "_qn-g";
export var senderDateCustomer = "_qn-h";
export var senderName = "_qn-d";
export var time = "_qn-k";
export var uploadedImage = "_qn-l";
export var username = "_qn-m";
export var xsmall = "_qn-n";